import styled, { css } from "styled-components";
import { fontMedium } from "../../_static/Typography";
import buildColor from "../../_static/ColorPalette";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: ${buildColor("white", "100")};
  padding: 12px;
`;

export const InputContainer = styled.div`
  position: relative;
`;

const textSharedStyles = css`
  font-family: ${fontMedium};
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
`;

export const ApplyButton = styled.button`
  border: none;
  outline: none;
  background-color: transparent;
  height: 32px;
  padding: 0 6px;
  position: absolute;
  top: 26px;
  right: 6px;
  color: ${buildColor("blue_accent", "500")};
  ${textSharedStyles}
`;

export const Title = styled.span`
  display: block;
  color: ${buildColor("grey", "900")};
  margin-bottom: ${({ mb }) => (mb ? `${mb}px` : 0)};
  ${textSharedStyles}
`;

export const ButtonContainer = styled.div`
  padding-top: 12px;
`;

export const PromosContainer = styled.div`
  padding-top: 12px;
`;

export const PromosList = styled.ul`
  padding-bottom: 12px;
`;

export const PromoListItem = styled.li`
  &:not(:last-child) {
    margin-bottom: 12px;
  }
`;

export const CircularLoadingContainer = styled.div`
  position: absolute;
  height: 24px;
  top: 30px;
  right: 12px;
  display: flex;
  align-items: center;

  & > div {
    position: relative;
  }

  span::after {
    content: initial;
    border: none;
  }
`;
